import {Component} from '@angular/core';
import {AppInitService} from '../../core/services/app-init.service';
import {ActivatedRoute, Router} from '@angular/router';
import {storageKey} from "../../api/enum/storage.constants";
import {SessionStorageService} from "../../core/services/session-storage.service";

@Component({
    selector: 'app-init',
    imports: [],
    templateUrl: './init.component.html',
    styleUrl: './init.component.scss'
})
export class InitComponent {
    constructor(
        private initService: AppInitService,
        private router: Router,
        private route: ActivatedRoute,
        private storage: SessionStorageService
    ) {
    }

    // http://localhost:4200/?token_type=admission&token=a62d582490ea67aa0524f13def3d57fb5efa624c9ed0e9fbf4d5e54a399379b9b6f11a3dc8b48a85d0bbec441d80d6f7ae9e702c5ee2657a4a8d7ad5d2dc6dac8d4948461d503a81cd86fcdc14d7746c224b67223f46337a37b8edb0f7fb2cfcd3b507d331636a00a40aaa10044e29e6526c09a1dc8607b6e2d4023d25a9fa23
    ngOnInit() {
        this.route.queryParams.subscribe(params => {
            const token = params['token'];
            const tokenType = params['token_type'];

            if (token && tokenType) {
                this.storage.set(storageKey.instituteToken, token);

                this.initService.init().subscribe(() => {
                    this.router.navigateByUrl('/landing');
                });
            } else {
                this.router.navigateByUrl('/not-found');
            }
        });
    }
}
